import FetchStatusRepository             from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository                  from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import ReservationHistoryRepository      from "../../../../domain/reservation/history/ReservationHistoryRepository";
import FetchStatusDataSource
                                         from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource                  from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import ReservationHistoryDataSource
                                         from "../../../../infrastructure/datasource/reservation/history/ReservationHistoryDataSource";
import { setReservationHistoriesAction } from "../../../../infrastructure/redux/reservation/history";

class GetCancelRequestedReservationHistory {
  constructor(
    private dispatch,
    private readonly repository: ReservationHistoryRepository = new ReservationHistoryDataSource(),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
  ) {
  }

  public execute(): void {
    this.fetchStatusRepository.start();
    try {
      this.repository.findByCancelRequested().then(value => this.dispatch(setReservationHistoriesAction(value)));
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetCancelRequestedReservationHistory;
